import { render, staticRenderFns } from "./PeopleDivisionChart.vue?vue&type=template&id=0b8e590f&"
import script from "./PeopleDivisionChart.vue?vue&type=script&lang=js&"
export * from "./PeopleDivisionChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports